import { render } from "./DefaultInstallBanner.vue?vue&type=template&id=03099696&scoped=true"
import script from "./DefaultInstallBanner.vue?vue&type=script&lang=js"
export * from "./DefaultInstallBanner.vue?vue&type=script&lang=js"

import "./DefaultInstallBanner.vue?vue&type=style&index=0&id=03099696&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03099696"]])

export default __exports__